<script>
const axios = require("axios");

export default {
	mixins: [require("@/mixins/backend-mixin").default],
	data() {
		return {
			USER_TYPES: []
		};
	},
	computed: {
		userTypes() {
			return this.USER_TYPES;
		}
	},
	async mounted() {
		await this.BACKEND_URL;
		await this.getUserTypes(1);
	},
	methods: {
		async getUserTypes(page) {
			// TODO
			// Fetch all

			// TODO
			// Caching
			const url = this.BACKEND_URL + "/api/allUserTypes?page=" + page;
			const thisVue = this;

			await axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						thisVue.USER_TYPES = response.data.data;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getUserTypeById(id) {
			var type = this.USER_TYPES.filter(type => type.id == id)[0];

			if (type) {
				return type.description;
			}

			return "DELETED USER-GROUP";
		}
	}
};
</script>